import RegistrationRoute from './registration/RegistrationRoute.svelte'
import OrganizationRoute from './organizations/OrganizationRoute.svelte'
import UserRoute from './users/UserRoute.svelte'
import HomeRoute from './home/HomeRoute.svelte'
import SummaryRoute from './summary/SummaryRoute.svelte'
import QuoteRoute from './quote/QuoteRoute.svelte'
import DownloadRoute from './download/DownloadRoute.svelte'
import {organizationsPageState} from "./organizations/organizationsState";
import {usersPageState} from "./users/usersState"
import {registerPageState} from './registration/registeredUser.js'
import {wrap} from 'svelte-spa-router/wrap'
import {get} from 'svelte/store'
import {summaryPageState} from "./summary/summary";

export default {
    '/': HomeRoute,
    '/registration': RegistrationRoute,
    '/organizations': wrap({
            component: OrganizationRoute,
            conditions: [
                (detail) => {
                    return get(registerPageState)
                }
            ]
        }),
    '/users': wrap({
        component: UserRoute,
        conditions: [
            (detail) => {
                return get(organizationsPageState) && get(registerPageState)
            }
        ]
    }),
    '/summary': wrap({
        component: SummaryRoute,
        conditions: [
            (detail) => {
                return get(organizationsPageState) && get(registerPageState) && get(usersPageState)
            }
        ]
    }),
    '/quote': wrap({
        component: QuoteRoute,
        conditions: [
            (detail) => {
                return get(organizationsPageState) && get(registerPageState) && get(usersPageState) && get(summaryPageState)
            }
        ]
    }),
    '/download': wrap({
        component: DownloadRoute,
        conditions: [
            (detail) => {
                return get(organizationsPageState) && get(registerPageState) && get(usersPageState) && get(summaryPageState)
            }
        ]
    })
}
